import React, { FC, useEffect, useRef } from 'react'
import styles from './facsimileGroup.module.scss'

type Props = {
  isFormVisible?: boolean
  value?: string
  onValueChange?: (value: string) => void
}

const HoneyPotForm: FC<Props> = ({ isFormVisible = false, value, onValueChange }) => {
  const hasFilledFax = useRef(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const input = inputRef.current
    if (!input) return

    const nativeDescriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      'value'
    )
    if (!nativeDescriptor?.set || !nativeDescriptor?.get) return

    const nativeSetter = nativeDescriptor.set
    const nativeGetter = nativeDescriptor.get
    const reactDescriptor = Object.getOwnPropertyDescriptor(input, 'value')

    Object.defineProperty(input, 'value', {
      configurable: true,
      get() {
        return nativeGetter.call(this)
      },
      set(val) {
        nativeSetter.call(this, val)
        this.dispatchEvent(new Event('input', { bubbles: true }))
        this.dispatchEvent(new Event('change', { bubbles: true }))
      },
    })

    return () => {
      if (reactDescriptor) {
        Object.defineProperty(input, 'value', reactDescriptor)
      } else {
        delete (input as any).value
      }
    }
  }, [])

  const pushToDataLayer = (data) => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }

  const handleFaxFocus = () => {
    pushToDataLayer({
      event: 'traffic_check',
      traffic_type: 'bot',
    })
  }

  const handleFaxChange = (e) => {
    const inputValue = e.target.value

    if (onValueChange) {
      onValueChange(inputValue)
    }

    if (inputValue.trim() && !hasFilledFax.current) {
      hasFilledFax.current = true

      pushToDataLayer({
        event: 'traffic_check',
        traffic_type: 'bot',
      })
    }
  }
  return (
    <div className={isFormVisible ? styles.facsimileNpcGroupVisible : styles.facsimileNpcGroup}>
      <label htmlFor='fax'>Fax</label>
      <input
        ref={inputRef}
        name='fax'
        type='text'
        value={value}
        onFocus={handleFaxFocus}
        onChange={handleFaxChange}
      />
    </div>
  )
}

export default HoneyPotForm
